import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/drone/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/drone/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { addGlobalEventProcessor, getCurrentHub } from '@sentry/core';
import { WINDOW } from '../helpers.js';

/** HttpContext integration collects information about HTTP request headers */
var HttpContext = /*#__PURE__*/function () {
  function HttpContext() {
    _classCallCheck(this, HttpContext);
    HttpContext.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  _createClass(HttpContext, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = HttpContext.id;
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "setupOnce",
    value: function setupOnce() {
      addGlobalEventProcessor(function (event) {
        if (getCurrentHub().getIntegration(HttpContext)) {
          // if none of the information we want exists, don't bother
          if (!WINDOW.navigator && !WINDOW.location && !WINDOW.document) {
            return event;
          }

          // grab as much info as exists and add it to the event
          var url = event.request && event.request.url || WINDOW.location && WINDOW.location.href;
          var _ref = WINDOW.document || {},
            referrer = _ref.referrer;
          var _ref2 = WINDOW.navigator || {},
            userAgent = _ref2.userAgent;
          var headers = _objectSpread(_objectSpread(_objectSpread({}, event.request && event.request.headers), referrer && {
            Referer: referrer
          }), userAgent && {
            'User-Agent': userAgent
          });
          var request = _objectSpread(_objectSpread({}, url && {
            url: url
          }), {}, {
            headers: headers
          });
          return _objectSpread(_objectSpread({}, event), {}, {
            request: request
          });
        }
        return event;
      });
    }
  }], [{
    key: "__initStatic",
    value: function __initStatic() {
      this.id = 'HttpContext';
    }
  }]);
  return HttpContext;
}();
HttpContext.__initStatic();
export { HttpContext };